import { render, staticRenderFns } from "./SupplierContactList.vue?vue&type=template&id=244a85ec"
import script from "./SupplierContactList.vue?vue&type=script&lang=js"
export * from "./SupplierContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports